export default __webpack_public_path__ + "static/media/Page16.42b2d223.txt";